var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 112,
    viewBox: "0 0 133 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7674 57.8573C76.8941 51.0979 83.6775 33.3553 76.918 18.2283C70.1585 3.10128 52.4157 -3.68178 37.289 3.07761C22.162 9.83712 15.3789 27.5796 22.1384 42.7066C28.8979 57.8336 46.6404 64.6168 61.7674 57.8573ZM26.4383 98.2883C35.8926 94.0636 40.1321 82.9744 35.9074 73.5202C31.6827 64.0658 20.5937 59.8263 11.1393 64.051C1.68496 68.2757 -2.55454 79.3648 1.67015 88.8191C5.8948 98.2734 16.9839 102.513 26.4383 98.2883ZM124.924 33.7429C129.149 43.1971 124.909 54.2863 115.455 58.511C106.001 62.7356 94.9117 58.4961 90.6871 49.0418C86.4624 39.5875 90.702 28.4984 100.156 24.2737C109.611 20.049 120.7 24.2885 124.924 33.7429ZM64.8272 64.7047C83.7357 56.2554 105.914 64.7345 114.363 83.643L132.722 124.728L64.2476 155.326L45.8888 114.241C37.4395 95.3324 45.9184 73.1541 64.8272 64.7047ZM32.1936 120.36C30.0735 115.615 28.7146 110.724 28.0648 105.822L26.9491 106.442C15.5227 113.109 10.7208 127.457 16.2409 139.81L30.01 170.624L50.5524 161.445L32.1936 120.36ZM166.959 109.428L153.19 78.6146C147.492 65.8639 132.877 59.8879 119.982 64.7487C123.2 68.5026 125.938 72.7782 128.058 77.5228L146.417 118.608L166.959 109.428Z",
    fill: "#5C6C8A",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon3);
export default __webpack_public_path__ + "static/media/stats_icon3.7c0dc334ece30f101a0370d6c8fe0021.svg";
export { ForwardRef as ReactComponent };